import { SortOrder } from '../types/app.types';

export interface ISort {
  orderBy: string;
  order?: SortOrder;
}
